export default `/* Ids Accordion Component */
:host {
  display: block;
}

:host([hidden]) {
  display: none;
}

/* Color Variant: Module Nav */
:host([color-variant=module-nav]) {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.color-variant-module-nav {
  display: flex;
  flex-direction: column;
  height: 100%;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2J1aWxkcy9pbmZvci1kZXNpZ24vZW50ZXJwcmlzZS13Yy9zcmMvY29tcG9uZW50cy9pZHMtYWNjb3JkaW9uIiwic291cmNlcyI6WyJpZHMtYWNjb3JkaW9uLnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7QUFFQTtFQUNFOzs7QUFHRjtFQUNFOzs7QUFHRjtBQUVBO0VBQ0U7RUFDQTtFQUNBOzs7QUFHRjtFQUNFO0VBQ0E7RUFDQSIsInNvdXJjZXNDb250ZW50IjpbIi8qIElkcyBBY2NvcmRpb24gQ29tcG9uZW50ICovXG5cbjpob3N0IHtcbiAgZGlzcGxheTogYmxvY2s7XG59XG5cbjpob3N0KFtoaWRkZW5dKSB7XG4gIGRpc3BsYXk6IG5vbmU7XG59XG5cbi8qIENvbG9yIFZhcmlhbnQ6IE1vZHVsZSBOYXYgKi9cblxuOmhvc3QoW2NvbG9yLXZhcmlhbnQ9XCJtb2R1bGUtbmF2XCJdKSB7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG4gIGhlaWdodDogMTAwJTtcbn1cblxuLmNvbG9yLXZhcmlhbnQtbW9kdWxlLW5hdiB7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG4gIGhlaWdodDogMTAwJTtcbn1cbiJdfQ== */`;
